import { render, staticRenderFns } from "./advertisement.vue?vue&type=template&id=73c4992e&scoped=true&"
import script from "./advertisement.vue?vue&type=script&lang=js&"
export * from "./advertisement.vue?vue&type=script&lang=js&"
import style0 from "./advertisement.vue?vue&type=style&index=0&id=73c4992e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c4992e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73c4992e')) {
      api.createRecord('73c4992e', component.options)
    } else {
      api.reload('73c4992e', component.options)
    }
    module.hot.accept("./advertisement.vue?vue&type=template&id=73c4992e&scoped=true&", function () {
      api.rerender('73c4992e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/advertisement.vue"
export default component.exports